import type { PicksAction } from '@/lib/picks/picksActionTypes'

/** Dispatched by `executePicksAction` when type is `request_booking`; listened by `RequestBookingHost`. */
export const WAGAMOUR_OPEN_REQUEST_BOOKING =
  'wagamour:open-request-booking'

export type RequestBookingOpenDetail = {
  action: PicksAction & { type: 'request_booking' }
}
